import { render, staticRenderFns } from "./ClientCardFinalPrice.vue?vue&type=template&id=5009d41d&scoped=true&"
import script from "./ClientCardFinalPrice.vue?vue&type=script&lang=js&"
export * from "./ClientCardFinalPrice.vue?vue&type=script&lang=js&"
import style0 from "./ClientCardFinalPrice.vue?vue&type=style&index=0&id=5009d41d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5009d41d",
  null
  
)

export default component.exports